import Vue from 'vue';

Vue.use({
  install(vue) {
      vue.prototype.$confirmCancel = new Vue();

      vue.prototype.$confirmCancel.show = (title: string, message: string, confirm: string) =>
        vue.prototype.$confirmCancel.$emit('show-confirm-cancel', title, message, confirm);

      vue.prototype.$confirmCancel.close = (confirmed: boolean) =>
        vue.prototype.$confirmCancel.$emit('confirm-cancel', confirmed);
  },
});
